export const AVATAR_COLORS = {
  A: '#DC4405',
  B: '#DC4405',
  C: '#E88F26',
  D: '#E88F26',
  E: '#EFB10A',
  F: '#EFB10A',
  G: '#1AAD7F',
  H: '#1AAD7F',
  I: '#00A8A9',
  J: '#00A8A9',
  K: '#008486',
  L: '#008486',
  M: '#0681FD',
  N: '#0681FD',
  O: '#1759D5',
  P: '#1759D5',
  Q: '#6C439B',
  R: '#6C439B',
  S: '#AA35A6',
  T: '#AA35A6',
  U: '#BF0C5F',
  V: '#BF0C5F',
  W: '#915C75',
  X: '#915C75',
  Y: '#484F65',
  Z: '#484F65',
} as const;
